export enum LoginType {
  Customer = 'Customer',
  Broker = 'Broker',
}

export const FORM_UTIL = {
  RUT: 'rut',
  PASSWORD: 'password',
};
